import { useEffect, useContext } from 'react';
import datadogRumClient from '../../../utils/datadog-rum';
import { useUser } from '../../../state/user';
import { getAnonymousId } from '..';
import { AnalyticsContext } from '../../../ModularReduxAnalytics';

const useDatadogRUM = () => {
  const { registeredUser } = useUser();
  const { segment } = useContext(AnalyticsContext);

  useEffect(() => {
    if (registeredUser) {
      const { id, phoneNumber } = registeredUser;

      const setRumUser = async () => {
        const anonymousId = await getAnonymousId(segment);
        datadogRumClient.setRumUser(anonymousId, { id, phoneNumber });
      };
      setRumUser();
    }
  }, [registeredUser]);
};

export default useDatadogRUM;
